import React from 'react';
import PropTypes from 'prop-types';
import SliderHandle from './SliderHandle';
import { dateToOffset } from './helpers';
import { useDraggable } from './hooks';
import { instanceOfDateString } from './propTypes';
import styles from './ScaleBar.module.css';

/*
 * This component is the actual slider bar that can be dragged around.
 */
const SliderBar = ({
  startDate,
  visibleStartDate,
  endDate,
  visibleEndDate,
  width,
  onStartDrag,
  onBarMove,
  onHandleMove,
}) => {
  const left = dateToOffset({
    startDate,
    endDate,
    width,
    date: visibleStartDate,
  });
  const right = dateToOffset({
    startDate,
    endDate,
    width,
    date: visibleEndDate,
  });
  const style = {
    marginLeft: left,
    marginRight: width - right,
  };

  const { dragProps, isDragging } = useDraggable({
    onStartDrag,
    onDragMove: onBarMove,
  });

  return (
    <div
      className={styles.sliderBar}
      data-testid='scale-bar-bar'
      style={style}
      {...dragProps}
    >
      <SliderHandle
        onStartDrag={onStartDrag}
        onHandleMove={onHandleMove}
        location='left'
        parentIsDragging={isDragging}
        tooltip={visibleStartDate}
      />

      <SliderHandle
        onStartDrag={onStartDrag}
        onHandleMove={onHandleMove}
        location='right'
        parentIsDragging={isDragging}
        tooltip={visibleEndDate}
      />
    </div>
  );
};

SliderBar.propTypes = {
  startDate: instanceOfDateString.isRequired,
  endDate: instanceOfDateString.isRequired,
  visibleStartDate: instanceOfDateString.isRequired,
  visibleEndDate: instanceOfDateString.isRequired,
  width: PropTypes.number.isRequired,
  onStartDrag: PropTypes.func.isRequired,
  onBarMove: PropTypes.func.isRequired,
  onHandleMove: PropTypes.func.isRequired,
};

export default SliderBar;
